import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { TooltipDirective } from '../../../tooltip/tooltip.directive';

@Component({
    selector: 'app-content-dropdown-item-cabinet',
    templateUrl: './content-dropdown-item.component.html',
    styleUrls: ['./content-dropdown-item.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [TooltipDirective],
    host: {
        '[class.locked]': 'locked()',
        '[class.disabled]': 'disabled()',
        '(click)': 'onHostClick($event)'
    }
})
export class ContentDropdownItemCabinetComponent {
    selected = input<boolean>(false);
    disabled = input<boolean>(false);
    locked = input<boolean>(false);
    lockedMessage = input<string>('Not available in your subscription');
    itemClick = output<void>();

    onHostClick(event: Event): void {
        if (this.disabled() || this.locked()) {
            event.stopImmediatePropagation();
            event.preventDefault();
        }
    }

    onClick(): void {
        if (!this.disabled() && !this.locked()) {
            this.itemClick.emit();
        }
    }
}
